import { IconComponentsProps } from './types';

const ArrowBackIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.15247 7.76629L10.0067 2.91211L10.6862 3.5917L6.51164 7.76629L10.6862 11.9409L10.0067 12.6205L5.15247 7.76629Z"
      fill={fill}
    />
  </svg>
);

export default ArrowBackIcon;
